import mammoth from "mammoth/mammoth.browser.min.js";
import html2pdf from "html2pdf.js";

const WordToPdfConverter = () => {
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.name.toLowerCase().endsWith(".docx")) {
      alert("Please select a .docx Word file");
      return;
    }

    try {
      const arrayBuffer = await file.arrayBuffer();
      const result = await mammoth.convertToHtml({ arrayBuffer });
      const htmlContent = result.value;

      // Create hidden temporary container for rendering
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlContent;
      Object.assign(tempDiv.style, {
        fontFamily: "Arial, sans-serif",
        fontSize: "12pt",
        lineHeight: "1.6",
        padding: "20mm", // margin on all sides
        background: "#fff",
        color: "#000",
        width: "210mm", // A4 width
        boxSizing: "border-box",
      });
      document.body.appendChild(tempDiv);

      const opt = {
        margin: [10, 0, 10, 0], // top, left, bottom, right (mm)
        filename: file.name.replace(/\.docx$/i, "") + ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        pagebreak: { mode: ["css", "legacy"] },
      };

      await html2pdf().set(opt).from(tempDiv).save();
      document.body.removeChild(tempDiv);
    } catch (error) {
      console.error("Conversion failed:", error);
      alert("An error occurred while converting the file.");
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Word (.docx) → PDF Converter</h2>
      <p style={styles.description}>
        Select a Word file to convert and download as PDF.
      </p>
      <input
        type="file"
        accept=".docx"
        onChange={handleFileChange}
        style={styles.fileInput}
      />
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    background: "#fff",
    padding: "40px",
    borderRadius: "10px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    width: "90%",
    maxWidth: "500px",
    margin: "100px auto",
  },
  heading: { marginBottom: "15px", color: "#333" },
  description: { color: "#666", fontSize: "14px", marginBottom: "20px" },
  fileInput: {
    border: "2px dashed #007bff",
    padding: "40px 20px",
    borderRadius: "10px",
    cursor: "pointer",
    background: "#f9fbff",
    color: "#007bff",
    transition: "0.3s",
    width: "100%",
  },
};

export default WordToPdfConverter;
